<template>
    <vx-box class="p-4 flex items-center gap-2">
        <div class="grow">
            <div class="flex items-center line-clamp-1 font-bold gap-2">
                <vx-popover v-if="!props.disabled" placement="top" class="h-5" arrow>
                    <span
                        class="transition cursor-pointer inline-block size-3.5 rounded-[3px]"
                        :style="{ backgroundColor: '#' + category.color }"
                    ></span>
                    <template v-slot:content="{ close }">
                        <div class="flex gap-2">
                            <div
                                v-for="option of THREAD_CATEGORY_COLORS_OPTIONS"
                                :key="option.value"
                                class="cursor-pointer hover:scale-110 active:scale-90 rounded size-10 transition outline outline-2 outline-offset-2"
                                :class="category.color === option.value ? '' : 'outline-transparent'"
                                :style="{
                                    backgroundColor: '#' + option.value,
                                    ...(category.color === option.value ? { outlineColor: '#' + option.value } : {}),
                                }"
                                @click="
                                    close();
                                    category = { ...category, color: option.value };
                                "
                            ></div>
                        </div>
                    </template>
                </vx-popover>
                <span
                    v-else
                    class="inline-block size-3.5 rounded-[3px]"
                    :style="{ backgroundColor: '#' + category.color }"
                ></span>

                {{ category.name }}
            </div>
            <div class="text-sm text-slate-500 line-clamp-2">
                {{ category.classification_instructions }}
            </div>
            <div v-if="category.description" class="text-xs text-slate-500">
                {{ category.description }}
            </div>
        </div>

        <vx-button
            data-test="delete-btn"
            outline
            color="muted"
            :disabled="props.disabled"
            @click="emit('delete', category)"
        >
            <font-awesome-icon widthAuto :icon="faTrash"></font-awesome-icon>
        </vx-button>
        <vx-button
            data-test="edit-btn"
            outline
            color="muted"
            :disabled="props.disabled"
            @click="emit('edit', category)"
        >
            Edit <font-awesome-icon widthAuto :icon="faFilePen"></font-awesome-icon>
        </vx-button>
    </vx-box>
</template>

<script lang="ts" setup>
import { faFilePen, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxBox, VxButton, VxPopover } from '@voxie/frontend-components';
import { THREAD_CATEGORY_COLORS_OPTIONS } from '~/constants/messageHub';
import type { ThreadCategoryType } from '~/services/threadCategories/threadCategoriesClient.types';

const props = defineProps<{
    disabled?: boolean;
}>();

const category = defineModel<ThreadCategoryType>({
    required: true,
});

const emit = defineEmits<{
    edit: [category: ThreadCategoryType];
    delete: [category: ThreadCategoryType];
}>();
</script>
